// @flow

import { AUTH_IN_PROGRESS, AUTH_SECCESS, AUTH_ERROR } from './actionTypes';
import Config from '../../core/config/index';

export function authInProgress() {
  return {
    type: AUTH_IN_PROGRESS,
  };
}

export function authSuccess() {
  return {
    type: AUTH_SECCESS,
  };
}

export function authError(layoutStaticData) {
  return {
    type: AUTH_ERROR,
    layoutStaticData,
  };
}

export function auth(payload) {
  // eslint-disable-next-line consistent-return
  return async (dispatch) => {
    dispatch(authInProgress());
    if (!payload) {
      return dispatch(authError(Config.payment.errorMessage));
    }

    switch (payload.code) {
      case 200:
        dispatch(authSuccess());
        break;
      case 404:
        dispatch(authError(payload));
        break;
      case 403:
        dispatch(authError(payload));
        break;
      default:
        dispatch(authError());
    }
  };
}
